import React, { useEffect, useState } from "react"

export const useWindowPaste = () => {
  const [pasteValue, setPasteValue] = useState('')

  useEffect(() => {
    window.addEventListener("paste", (e) => {
      setPasteValue(e.clipboardData.getData("text"))
    });

    return () => {
      window.removeEventListener("paste", null);
    };
  }, [])

  return pasteValue;
}